<template>
    <!--
    Gravatar component
    Styled gravatar component

    @property {String} email
    -->
    <figure class="gravatar" :class="{ 'gravatar-x2': local }">
        <img :src="image">
    </figure>
</template>

<script>
import md5 from 'blueimp-md5';
import gravatarFallback from '../../../assets/img/no_gravatar.jpg'

export default
{
    name: 'Gravatar',

    data()
    {
        return {
            image: gravatarFallback,
        }
    },

    props:
    {
        email: '',
        local:
        {
            default: false
        },

        user:
        {
            default: false
        }
    },

    created()
    {
        this.getGravatar(this.email)
    },

    methods:
    {
        /**
         * Get the gravatar from provider
         *
         * @param {String} email
         * @returns {string}
         */
        getGravatar(email)
        {
            let url = '/api/gravatar';

            if (this.user) url += '/' + this.user + '/user';

            if (this.local)
            {
                this.$http.get(url, { responseType: 'arraybuffer' })
                .then(response =>
                {
                    if (response.status === 200)
                    {
                        let image = btoa(
                            new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                        );

                        this.imgLoaded();

                        return this.image = `data:${response.headers['content-type'].toLowerCase()};base64,${image}`;
                    }

                    this.imgLoaded();

                    return this.image = gravatarFallback
                })
            }
            else
            {
                let user = email || '',
                    hash = md5(user.trim().toLowerCase());

                this.imgLoaded();

                return this.image = '//www.gravatar.com/avatar/' + hash + '?d=mm';
            }
        },

        imgLoaded()
        {
            this.$emit('loaded', true);
        }
    },
}
</script>



// WEBPACK FOOTER //
// Gravatar.vue?5ad250b2